import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useDeleteMatter = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (matterId: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}`, fetchConfig);

      if (!res.ok) {
        throw new Error(`Failed to delete matter: ${res.statusText}`);
      }

      return matterId;
    },
    onSuccess: () => {
      toast.success('Matter deleting...');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matters] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.MatterV2] });
    },
    onError: (error) => {
      console.error('Delete matter error:', error);
      toast.error('Failed to delete matter. Please try again.');
    },
  });
};
